import { AppService } from "app/services/app.service";

import { AssembleiaItemOpcaoVoto } from "app/pages/full-pages/assembleia/model/AssembleiaItemOpcaoVoto";

export abstract class AbOpcaoVoto extends AppService {
  abstract prefixo: string;
  abstract salvarAlterarDados(entity: AssembleiaItemOpcaoVoto)
  abstract getAllOpcaoVoto();
}